<template>
    <section>
      <div class="graph-display">
        <div class="container display-block" v-if="!loading">
          <div class="row">
          <div class="container">
            <div class="date">
               <datepicker v-model="value"></datepicker>

            </div>
          </div>
            <!-- <div class="col-sm-4">
              <weather-widget></weather-widget>
            </div> --><!-- end col -->
            <div class="col-sm-12">
              <div class="right-display table-responsive">
                <div id="container"  style="min-width: 400px; height: 400px; margin: 0 auto">
                  <highcharts :options="options" ></highcharts>
                </div>
              </div><!-- end right-display -->
            </div><!-- end col -->
          </div><!-- end row -->

          <div class="left-content-chart clearfix">
            <div class="table-responsive">
              <div class="fix"  v-on:click="show = !show"><span id="toggleSlider"><i class="fa fa-bar-chart" aria-hidden="true"></i></span></div>
              <transition name="slide-fade">
              <ul class="slide" v-if="show">
                <li>
                   <div class="color-chart">
                      <div class="green default-color">
                        <h3>
                          राम्रो, स्वास्थ लाई कुनै फरक नपर्ने
                          </h3>
                      </div>
                      <h4> < 10 µg/m<sup>3</sup></h4>
                   </div><!-- end of color-chart -->
                </li>
                <li>
                   <div class="color-chart">
                      <div class="light-green default-color">
                        <h3>
                          राम्रै, WHO को दैनिक मापदण्ड भित्र
                          </h3>
                      </div>
                      <h4>10 - 25 µg/m<sup>3</sup></h4>
                   </div><!-- end of color-chart -->
                </li>
                <li>
                   <div class="color-chart">
                      <div class="yellow default-color">
                        <h3>
                          हल्का प्रधुषित, दैनिक मापदण्ड भित्र
                          </h3>
                      </div>
                      <h4>25 - 40 µg/m<sup>3</sup></h4>
                   </div><!-- end of color-chart -->
                </li>
                <li>
                   <div class="color-chart">
                      <div class="dark-yellow default-color">
                        <h3>
                          भिप्रधुषित, दुर्बल हरुको लागि अस्वस्थ
                          </h3>
                      </div>
                      <h4> 40 - 75 µg/m<sup>3</sup></h4>
                   </div><!-- end of color-chart -->
                </li>
                <li>
                   <div class="color-chart">
                      <div class="red default-color">
                        <h3>
                          अत्ति प्रधुषित, मास्क लगाउन उपुक्त
                          </h3>
                      </div>
                      <h4> 75 - 150 µg/m<sup>3</sup></h4>
                   </div><!-- end of color-chart -->
                </li>
                <li>
                   <div class="color-chart">
                      <div class="purple default-color">
                        <h3>
                          खतराजनक, सकेसम्म जोगिएर बस्नुहोस
                          </h3>
                      </div>
                      <h4> > 150 µg/m<sup>3</sup></h4>
                   </div><!-- end of color-chart -->
                </li>
               </ul>
               </transition>
            </div>

            </div><!-- end of left-content-chart -->
        </div><!-- end display-block -->
        <div class="container display-block" v-if="loading">Loading</div><!-- end display-block -->

       </div><!-- end graph-display -->

    </section>
</template>

<script>
import {HTTP} from '../http-common.js'
import Vue from 'vue';
import VueHighcharts from 'vue-highcharts';
import Datepicker from './Datepicker.vue';
// import WeatherWidget from './WeatherWidget.vue';

import * as moment from 'moment-timezone';
var current_time = moment().tz("Asia/Kathmandu").format("h");
// Vue.use(VueHighcharts);
// global register

var options = {
  chart: {
      zoomType: 'xy'
  },
  title: {
      text: ''
  },
  xAxis: [{
      categories: [],
      crosshair: true,
      max:23
  }],
  yAxis: 
  // { // Primary yAxis
  //     // labels: {
  //     //     format: '{value}',
  //     //     style: {
  //     //         color: '#90ed7d'
  //     //     }
  //     // },
  //     // title: {
  //     //     text: 'Temperature (°C)',
  //     //     style: {
  //     //         color: '#90ed7d'
  //     //     }
  //     // },
  //     opposite: true,
  //     max : 40

  // }, 
  { // Secondary yAxis
      max : 150,
      gridLineWidth: 0,
      title: {
          text: 'Fine Particulate Matter',
          style: {
              color: '#000'
          }
      },
      labels: {
          format: '{value}',
          style: {
              color: '#000'
          }
      }
  },
tooltip: {
    shared: true
},
legend: {
    layout: 'vertical',
    backgroundColor: '#FFFFFF'
},
credits: {
  enabled: false
},
series: [{
    name: 'PM2.5',
    type: 'column',
    // yAxis: 1,
    data: [],
    tooltip: {
        valueSuffix: ' µg/m³'
    },
    showInLegend: false,
}
// {
//     name: 'Temperature',
//     type: 'spline',
//     color: '#90ed7d',
//     data: [],
//     tooltip: {
//         valueSuffix: ' °C'
//     },
//     showInLegend: false,
// }
]};

export default {
  name: 'charts',
  data () {
    return {
      fetchedData: null,
      loading: true,
      error: false,
      show: true,
      pollutionTitle : null,
      chartTitle : null,
      categories : null,
      pollutionData : null,
      weathersData : null,
      query: '',
      value:'',
      options: options
    }
  },
   watch: {
    value: function() {
      this.fetchData(this.value)
    }
  },
  created: function(){
    this.fetchData()
  },
  methods : {
              fetchData(value='') {
                var vm = this
                this.loading = false
                var url = 'pollution-weather'
                if(value!=''){

                  var  dateValue = new Date(value)
                  var dateFormat = this.parseDate(dateValue)
                  url = url+'?date='+dateFormat

                }else{
                  var  dateValue = new Date()
                  var dateFormat = this.parseDate(dateValue)
                }
                //var  dateValue = new Date()
                //var dateFormat = this.parseDate(dateValue)
                var todayDate = new Date()
                todayDate = this.parseDate(todayDate)
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response

                    // console.log(moment(jsonData.data.date,"MM/DD/YYYY").format('YYYY-MM-DD'))
                    this.loading = false
                    this.fetchedData = jsonData
                    console.log(this.fetchedData)
                    this.categories = this.getcategories(jsonData.data.data)
                    this.pollutionData = this.getpollution(jsonData.data.data)
                    console.log(this.pollutionData)

                    this.weathersData = this.getweather(jsonData.data.data)
                    if(jsonData.data.date==todayDate){
                      this.pollutionTitle = "Average Hourly  Pollution Data of Kathmandu for today"
                      this.chartTitle = "Average Hourly  Pollution Data of Kathmandu"
                    }else{
                      this.pollutionTitle = "Pollution Data of "+jsonData.data.city+" for "+jsonData.data.date
                      this.chartTitle = "Average Pollution Data of "+jsonData.data.city+" for "+jsonData.data.date
                    }
                    // console.log(this.chartTitle)
                    this.options.xAxis[0].categories = this.categories
                    this.options.series[0].data = this.pollutionData
                    // this.options.series[1].data = this.weathersData
                    this.options.title.text = this.chartTitle

                  }
                })
                .catch(e => {
                  this.error = true
                })
              },
              getcategories: function(data){
                var arr = [];
                data.forEach(function(d) {

                  var from = d.hours
                  var to = parseInt(d.hours) + 1
                  var hours = from.toString()+'-'+to.toString()
                  if(d.hours>=12){
                    if(d.hours==12){
                      hours = "12-1PM"
                    }
                    else if (d.hours==23) {
                      hours = "11-midnight"
                    }
                    else{
                      hours = (from-12)+'-'+(to-12)+'PM'
                    }
                  }else{
                    if(d.hours==0){
                      hours = "midnight-1AM"
                    }else{
                        hours = from+'-'+to+'AM'
                    }
                  }
                  arr.push(hours)
                })
                return arr
              },
              getpollution: function(data){
                var arr = []
                var colors = "#1db151"
                data.forEach(function(d) {
                  if(d.pollutions.value < 10){
                    colors = "#1db151";
                  }
                  else if(d.pollutions.value >= 10 && d.pollutions.value < 25){
                    colors = "#94C953";
                  }
                  else if(d.pollutions.value >= 25 && d.pollutions.value < 40){
                    colors = "#F3EC18";
                  }
                  else if(d.pollutions.value >= 40 && d.pollutions.value < 75){
                    colors = "#FDC00F";
                  }
                  else if(d.pollutions.value >= 75 && d.pollutions.value < 150){
                    colors = "#ed1e24";
                  }
                  else if(d.pollutions.value >= 150){
                    colors = "#85439a";
                  }else{
                    colors = "#1db151";
                  }
                  if(d.pollutions.value!=0){
                    arr.push({
                        y: d.pollutions.value,
                        color:  colors
                    });
                  }
                })
                return arr
              },
              getweather: function(data){
                var arr = []
                data.forEach(function(d) {
                  var marker = d.weathers.marker
                  var temp = d.weathers.temp
                  if(d.weathers.temp!=0){
                    if(marker!=''){
                      arr.push({
                          y: temp,
                          marker: marker
                      });
                    }else{
                      arr.push(temp)
                    }
                  }

                })
                return arr
              },
              getWindDirection:function(degree){
              },
              parseDate:function(dateValue){
                var year = dateValue.getFullYear()+""
                var month = ('0' + (dateValue.getMonth()+1)).slice(-2)+""
                var day = ('0' + dateValue.getDate()).slice(-2)+""
                var dateFormat = year + "-" + month + "-" + day
                return dateFormat
              }
  },
  components: {
      Datepicker
      // WeatherWidget
  }
}

</script>
<style src="../assets/style.css"></style>
<style>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Charts.vue?985c5e20